import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    if (!value.startsWith('+')) {
      return value; 
    }

    const match = value.match(/^(\+\d{1,4})(.*)$/);
    // console.log('match', match);
    if (!match) {
      return value; 
    }

    const code = match[1];
    const number = match[2].replace(/\s+/g, ''); 

    // console.log( `${code} ${number}`)

    return `${code} ${number}`;
  }
}

